// extracted by mini-css-extract-plugin
export default {"icon":"appRow_icon__bg9Kk","popupImg":"appRow_popupImg__AN4Ug","changeIconTooltip":"appRow_changeIconTooltip__2DeGn"};